import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 4C4 2.89543 4.89543 2 6 2H14C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9H15C13.8954 9 13 8.10457 13 7V4H6V20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H6C4.89543 22 4 21.1046 4 20V4ZM15 5.41421L16.5858 7H15V5.41421Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.7929 11.7929C18.1834 11.4024 18.8166 11.4024 19.2071 11.7929L21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071L19.2071 18.2071C18.8166 18.5976 18.1834 18.5976 17.7929 18.2071C17.4024 17.8166 17.4024 17.1834 17.7929 16.7929L18.5858 16H11C10.4477 16 10 15.5523 10 15C10 14.4477 10.4477 14 11 14H18.5858L17.7929 13.2071C17.4024 12.8166 17.4024 12.1834 17.7929 11.7929Z",
		fill: "currentColor"
	})]
});
export default SvgExport;
